/// <amd-module name="Environments/EnvironmentRunDetails/Stores/JobsStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { JobsActions } from "Environments/EnvironmentRunDetails/Actions/JobsActions";
import { StoreBase } from "Environments/Flux/Store"
import { EnvironmentStageDeploymentData, EnvironmentPhaseJobRecord } from "Environments/RemoteClients/Contracts/Traceability";

export class JobsStore extends StoreBase {

    public static getKey(): string {
        return "environment-deployments-job-history-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        
        this._actionsHub = ActionsHubManager.GetActionsHub<JobsActions>(JobsActions, instanceId);
        this._actionsHub.setDeploymentJobs.addListener(this._setDeploymentJobs)
    }
    
    protected disposeInternal(): void {
        this._actionsHub.setDeploymentJobs.removeListener(this._setDeploymentJobs);
    }

    public getState(): EnvironmentStageDeploymentData {
        return this._state || {};
    }

    public getJobs(): EnvironmentPhaseJobRecord[] {
        return this._state && this._state.jobs ? this._state.jobs : [];
    }

    private _setDeploymentJobs = (stageData: EnvironmentStageDeploymentData): void => {
        this._state = stageData || [];
        this.emitChanged();
    }

    private _actionsHub: JobsActions;
    private _state: EnvironmentStageDeploymentData;
}
